module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pa-5 pt-0 pb-0"
  }, [_c('v-row', {
    staticStyle: {
      "justify-content": "between"
    }
  }, [_c('v-col', {
    staticClass: "sub-title",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("Campaign Brief")]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-text-field', {
    staticClass: "mt-0",
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedFilter.search),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "search", $$v)
      },
      expression: "selectedFilter.search"
    }
  })], 1), _vm._v(" "), (_vm.isSuperAdmin || _vm.isAM) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.AM,
      "item-value": "id",
      "item-text": "name",
      "label": "AM",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.AM),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "AM", $$v)
      },
      expression: "selectedFilter.AM"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSuperAdmin || _vm.isCC) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.CC,
      "item-value": "id",
      "item-text": "name",
      "label": "CC",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.CC),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "CC", $$v)
      },
      expression: "selectedFilter.CC"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pa-5 pt-2"
  }, [_c('v-data-table', {
    staticClass: "campaign-brief-data-table elevation-1",
    attrs: {
      "loading": _vm.loading,
      "headers": _vm.headers,
      "items": _vm.filteredItems,
      "search": _vm.selectedFilter.search,
      "items-per-page": 5
    },
    scopedSlots: _vm._u([{
      key: "item.timeline",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center " + (item.overdue ? 'overdue-highlight' : ''))
        }, [(_vm.isLinkAllow) ? _c('a', {
          staticClass: "custom-link",
          attrs: {
            "href": ("/campaigns/timeline?campaignID=" + (item.campaignID)),
            "target": '_blank'
          }
        }, [_vm._v("\n            " + _vm._s(item.startDate || '') + " - " + _vm._s(item.endDate || '') + "\n          ")]) : _c('span', [_vm._v(_vm._s(item.startDate || '') + " - " + _vm._s(item.endDate || ''))])])]
      }
    }, {
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-left " + (item.overdue ? 'overdue-highlight' : ''))
        }, [_c('a', {
          staticClass: "custom-link",
          on: {
            "click": function($event) {
              return _vm.openCampaignModal(item.campaignID)
            }
          }
        }, [_vm._v(_vm._s(item.name || ''))])])]
      }
    }, {
      key: "item.status",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center " + (item.overdue ? 'overdue-highlight' : ''))
        }, [_c('a', {
          staticClass: "custom-link",
          attrs: {
            "href": '/campaigns/pending_approval?campaignID=' + item.campaignID,
            "target": "_blank"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.getDashboardStatusDisplay(item.status)) + "\n          ")])])]
      }
    }, {
      key: "item.AMDeadline",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center " + (item.overdue ? 'overdue-highlight' : ''))
        }, [(_vm.isLinkAllow) ? _c('a', {
          staticClass: "custom-link",
          attrs: {
            "href": ("/campaigns/timeline?campaignID=" + (item.campaignID)),
            "target": '_blank'
          }
        }, [_vm._v("\n            " + _vm._s(item.AMDeadline ? _vm.formatDate(item.AMDeadline) : '') + "\n          ")]) : _c('span', [_vm._v(_vm._s(item.AMDeadline ? _vm.formatDate(item.AMDeadline) : ''))])])]
      }
    }], null, true)
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-309780bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/DashboardComponents/CampaignBriefDataTable.vue
// module id = 2067
// module chunks = 0